<template>
    <div class="DamageEntry">
        <div class="DamageLabel">{{ DamageCategory }}</div>
        <div class="Remark">{{ Remark }}</div>
    </div>
</template>

<script>
export default{
    props:{
        DamageCategory: String,
        Remark: String,
    }
}
</script>

<style>
.DamageEntry
{
    border: 1px solid gray;
    border-radius: 8px;
    padding: 5px 10px;
}

.DamageEntry + .DamageEntry
{
    margin-top: 9px;
}

.DamageLabel
{
    font-weight: bold;
    margin-bottom: 4px;
}
</style>